module.exports = __webpack_public_path__ + "img/login-logo.d9f31628.png";